// extracted by mini-css-extract-plugin
export default {"button":"no-z","reviewSort":"oo-z"};